export const REPORT_ID = 'slide-16';
export const SLIDE_NUMBER = 16;